import Axios from 'axios'
import store from './index'

const defaultState = () => ({
  isLoggingIn: false,
  isAuthenticated: false,
  token:null,
  userData:null
})

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    setIsLoggingIn(state, payload) {
      state.isLoggingIn = payload
    },
    setToken(state, payload){
      state.token = payload
    },
    setIsAuthenticate(state, payload){
      state.isAuthenticated = payload
    },
    setUserData(state, payload){
      state.userData = payload
    },
    logout(state){
      localStorage.setItem('token', '')
      Object.assign(state, defaultState())
      store.commit('collection/reset')
      store.commit('fetchPaper/reset')
      store.commit('createCollection/reset')
      store.commit('fetchPaper/reset')
      store.commit('saveRecord/reset')
      store.commit('shareCollection/reset')
      store.commit('editPaper/reset')
    }
  },
  getters: {

  },
  actions: {
    async login({ commit }, { username, password }) {
      const SERVER_ADDRESS = this._vm.$config[process.env.NODE_ENV].SERVER_ADDRESS
      const API = this._vm.$config[process.env.NODE_ENV].API

      commit('setIsLoggingIn', true)

      const url = SERVER_ADDRESS + API.LOGIN
      const authorizationBasic = window.btoa(username + ":" + password)
      const config={
        'headers':{
          'Authorization' : 'Basic ' + authorizationBasic,
        }
      }

      let loginResult = null;

      await Axios.get(
        url, config
      ).then(resp=>{
        commit('setToken', resp.data.token)
        commit('setIsAuthenticate', true)
        commit('setUserData', resp.data.userData)
        localStorage.setItem('token',resp.data.token)
        loginResult = 'success'
      }).catch((err)=>{
        loginResult = false
        if (!err.response){
          loginResult = 'connection_error'
        }
        else if(err.response.status == 401){
          loginResult = 'wrong_userpass'
        }else{
          loginResult = 'connection_error'
        }
      })
      commit('setIsLoggingIn', false)

      return loginResult
    }
  }
}